import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BusinessDataService } from 'src/app/data-repositories/business-data.service';
import { AuthService } from 'src/app/repositories/auth.service';

@Component({
  standalone: false,
  selector: 'app-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.scss']
})
export class DocumentViewerComponent implements OnInit {
  @ViewChild('pdfViewerOnDemand') pdfViewerOnDemand;
  @ViewChild('pdfViewerAutoLoad') pdfViewerAutoLoad;

  formNo: string;

  constructor(
    private service: BusinessDataService,
    private authService: AuthService,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.formNo = params.formNo;

      if (!this.authService.accessToken && params.token) {
        this.authService.accessToken = params.token;
      }

      this.downloadForm(this.formNo);
    });
  }

  downloadForm(formNo: string,) {
    this.service.openForm(formNo, blob => {
      this.pdfViewerAutoLoad.pdfSrc = blob;

      this.pdfViewerAutoLoad.refresh();
    });
  }

}
